import io from 'socket.io-client';
import { DEPLOYENVIRONMENT, PRESENCE_PORT } from 'apiConfig';

export const socket = io(`wss://${DEPLOYENVIRONMENT}socket.garlicerp.com:${PRESENCE_PORT}`, {
	transports: ['websocket', 'webtransport'],
	autoConnect: true,
});
